$('html').removeClass('no-js');

$(function () {
    /* global Modernizr:true */

    var _this = this,
        _body = $('body');
    /**
     * Initialize
     */
    _this.init = function()
    {
        $('a[rel="external"]').attr('target', '_blank');

        // navigation
        $('.hamburger').on('click', function() {
            $(this).parent().toggleClass('open');
            $(this).toggleClass('open');
        });

        // carousel
        $('#news-carousel .news-carousel').slick({
            nextArrow: $('.carousel-controls .next-slide'),
            prevArrow: $('.carousel-controls .previous-slide'),
            appendArrows: false
        });

        // carousel
        $('#headliner-slider').slick({
            appendArrows: false,
            nextArrow: $('#headliner-slider-controls .next'),
            prevArrow: $('#headliner-slider-controls .previous'),
            autoplay: true,
            autoplaySpeed: 5000
        });

        // beautify dropdown by semantic
        $('.ui.dropdown').dropdown();

        // modal
        $('.settings-modal').modal({
            centered: false,
            transition: 'fade up',
            autofocus: false
        });

        $('#personal-settings .settings button').on('click', function(e) {
            e.preventDefault();
            $('.settings-modal').modal('show');
        });


        /**
         * Count comments, show 10 and show 'more' to load more
         * @type {jQuery}
         */
        count_comments = $("#comments .comment").size();
        var x=10;
        $('#comments .comment:lt('+x+')').show();
        $('#loadmore').click(function () {
            x = (x+5 <= count_comments) ? x+5 : count_comments;
            $('#comments .comment:lt('+x+')').show();

            if (x == count_comments)
            {
                $('#loadmore').hide();
            }
        });
        $('#showless').click(function () {
            x=(x-5<0) ? 3 : x-5;
            $('#comments .comment').not(':lt('+x+')').hide();
        });

        /***************************************************************************
         ***************************************************************************
         *
         *   Ajax form submission (sidebar)
         *
         ***************************************************************************
         ****************************************************************************/
        $(".ajax-form").submit(function(e) {

            e.preventDefault(); // avoid to execute the actual submit of the form.

            var form = $(this);
            var url = form.attr('action');

            $.ajax({
                   type: "POST",
                   url: url,
                   data: form.serialize(), // serializes the form's elements.
                   success: function(data)
                   {
                       alert('Serialized form data = ' + form.serialize());
                   }
                 });


        });

        /**
         * Logo carousel BUSINESS
         */
        $('.reference').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            dots: false,
            prevArrow: true,
            nextArrow: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

        $('button.slick-previous').click(function(){
            $(".reference").slick('slickPrev');
        });

        $('button.slick-next').click(function(){
            $(".reference").slick('slickNext');
        });

        /**
         *
         * Save region
         *
         */
        $('#personal-settings .ui.dropdown, #settings-form .ui.dropdown').dropdown('setting', 'onChange', function(val) {
            $.ajax({
                url: '/profiel/',
                type: 'POST',
                data: { region_id: val, ajax: 1 }
            }).done(function (response) {
                $('.region').html(response);

                if (window.location.pathname == '/')
                {
                    window.location.href = '/';
                }
                else
                {
                    window.location.href = '/nieuws/' + response + '/';
                }
            });

        });

        /**
         *
         * Save themes
         *
         */

        $("#settings").submit(function(e) {

            e.preventDefault(); // avoid to execute the actual submit of the form.

            var form = $(this);
            var url = form.attr('action');

            $.ajax({
                url: url,
                type: 'POST',
                data: form.serialize(),
            }).done(function (response) {
                console.log(response);
                $('.settings-modal').modal('hide');
                location.reload();
            });

        });

        /**
         *
         * Save favorites
         *
         */
        $('.favorite').click(function (e) {
            e.preventDefault();
            console.log('start ajax call form');
            var id = $(this).data('id');
            var link = $(this);


            $.ajax({
                url: $(this).data('uri') + '/',
                type: 'POST',
                data: { id: id, ajax: 1, action: $(this).data('action') }
            }).done(function (response) {
                link.hide().html(response).fadeIn('slow');
            });

            return false;
        });



        /**
         * edit comment show edit form
         */
        $(document).on('click', '.edit-comment', function (e) {
            e.preventDefault();
            var commentId = $(this).data('commentid');
            var parentElement = $(this).parents('.comment');
            var comment = parentElement.find('p');
            console.log(commentId);
            $(this).parent().remove();
            comment.after('<div class="editcontainer"><form><textarea>' + comment.html() + '</textarea></form><br> <div class="btn btn-default "> <a class="update-edit-comment" data-commentid="' + commentId + '" href="#">Opslaan</a></div></div>');
            comment.remove();
        });

        /**
         * save edited comment
         */
        $(document).on('click', '.update-edit-comment', function (e) {
            e.preventDefault();
            var parentElement = $(this).parents('.comment');
            var editContainer = $(this).parent().parent();
            var content = parentElement.find('textarea').val();
            var commentId = $(this).data('commentid');

            $.ajax({
                url: window.location.pathname,
                type: 'POST',
                data: {commentId: commentId, content: content, ajax: 1, type: 'edit'}
            }).done(function (response) {
                editContainer.after('<p>' + content + '</p>');
                editContainer.remove();
                parentElement.prepend('<div class="btn btn-default "> <a class="edit-comment" data-commentid="' + commentId + '" href="#">Aanpassen</a></div>');
            });

            return false;
        });

        /**
         * remove comment
         */
        $(document).on('click', '.remove-comment', function (e) {
            e.preventDefault();
            var parentElement = $(this).parents('.comment');
            var commentId = $(this).data('commentid');

            $.ajax({
                url: window.location.pathname,
                type: 'POST',
                data: {commentId: commentId, ajax: 1, type: 'remove'}
            }).done(function (response) {
                parentElement.remove();
            });
            return false;
        });
    };

    if ($('#placement').val() == 'top')
        $('.top-banner').toggle();
    else if ($('#placement').val() == 'side')
        $('.side-banner').toggle();


    /**
     *  If body is not loaded, init
     */
    if (!_body.hasClass('loaded'))
    {
        _this.init();
    }
});


$('#placement').change(function () {
    var val = $(this).val();
    if (val === 'top') {
        if ($('.side-banner').is(':visible'))
            $('.side-banner').toggle();

        $('.top-banner').toggle();
    } else if (val === 'side') {
        if ($('.top-banner').is(':visible'))
            $('.top-banner').toggle();

        $('.side-banner').toggle();
    }
});

$('#date_from').change(function () {
    var picked_date = $(this).val();
    var date = new Date(picked_date);
    date.setDate(date.getDate()+1);
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    date = yyyy + '-' + mm + '-' + dd;
    $('#date_till').attr('min', date);
});